import React from "react";
import PropTypes from "prop-types";
import { getFileIcon } from "../../../utils/fileUtils";
PropTypes;

const AttachmentIcon = ({ file }) => {
  return <i className={getFileIcon(file)} />;
};

AttachmentIcon.propTypes = {
  file: PropTypes.any,
};

export default AttachmentIcon;
